module.exports = __webpack_public_path__ + "j.no1.f0acbb76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/j.no1.jpg
// module id = rE6k
// module chunks = 0